import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";

import heroImage from "../../../../Assets/Images/legal-services/legalservice.webp";
import ContactModal from "../../../../Assets/Common/ContactModal";

const HeroSection = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleConsultation = () => {
    setIsContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setIsContactModalOpen(false);
  };

  return (
    <>
      <section
        className="
          relative
          overflow-hidden
          bg-[#061426]
        "
      >
        <div
          className="
            absolute
            inset-0
            bg-cover
            bg-[center_right]
            bg-no-repeat
          "
          style={{
            backgroundImage: `url(${heroImage})`,
          }}
        />

        <div className="absolute inset-0 bg-black/15" />

        <div
          className="
            absolute
            inset-0
            bg-gradient-to-r
            from-[#061426]/90
            via-[#061426]/55
            to-transparent
          "
        />

        <div
          className="
            absolute
            inset-0
            bg-gradient-to-b
            from-transparent
            via-transparent
            to-[#061426]/25
          "
        />

        <div
          className="
            absolute
            inset-0
            opacity-[0.07]
          "
          style={{
            backgroundImage: `
              linear-gradient(
                to right,
                rgba(255,255,255,0.15) 1px,
                transparent 1px
              ),
              linear-gradient(
                to bottom,
                rgba(255,255,255,0.15) 1px,
                transparent 1px
              )
            `,
            backgroundSize: "55px 55px",
          }}
        />

        <div
          className="
            relative
            z-10
            mx-auto
            flex
            min-h-[390px]
            w-full
            max-w-7xl
            items-center
            px-4
            py-10
            sm:min-h-[410px]
            sm:px-6
            sm:py-12
            lg:min-h-[430px]
            lg:px-8
            lg:py-14
          "
        >
          <div
            className="
              w-full
              max-w-3xl
              text-left
            "
          >
            <motion.h1
              initial={{
                opacity: 0,
                y: 25,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                delay: 0.15,
                duration: 0.7,
              }}
              className="
                max-w-3xl
                pt-20
                text-3xl
                font-bold
                leading-[1.08]
                tracking-tight
                text-white
                sm:text-4xl
                md:text-5xl
                lg:text-6xl
              "
            >
              Simplifying{" "}
              <span className="text-orange-500">
                Legal Compliance
              </span>{" "}
              For Every Business
            </motion.h1>

            <motion.p
              initial={{
                opacity: 0,
                y: 25,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                delay: 0.3,
                duration: 0.7,
              }}
              className="
                mt-4
                max-w-2xl
                text-xs
                leading-5
                text-white/90
                sm:mt-5
                sm:text-sm
                sm:leading-6
                md:text-base
                md:leading-7
                lg:text-lg
              "
            >
              From business registration and taxation to licensing,
              intellectual property, certifications, and legal
              documentation, Webbocket provides end-to-end legal
              services that help startups, MSMEs, and enterprises
              stay compliant and grow with confidence.
            </motion.p>

            <motion.div
              initial={{
                opacity: 0,
                y: 25,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                delay: 0.45,
                duration: 0.7,
              }}
              className="
                mt-6
                flex
                flex-col
                gap-3
                sm:mt-7
                sm:flex-row
                sm:flex-wrap
                sm:gap-4
              "
            >
              <button
                type="button"
                onClick={handleConsultation}
                className="
                  group
                  inline-flex
                  w-full
                  items-center
                  justify-center
                  gap-2.5
                  rounded-xl
                  bg-orange-500
                  px-5
                  py-3
                  text-sm
                  font-semibold
                  text-white
                  shadow-lg
                  shadow-orange-500/20
                  transition-all
                  duration-300
                  hover:-translate-y-0.5
                  hover:bg-orange-600
                  hover:shadow-orange-500/30
                  active:translate-y-0
                  sm:w-auto
                  sm:px-6
                  sm:py-3.5
                  sm:text-base
                "
              >
                <span>Get Free Consultation</span>

                <span
                  className="
                    flex
                    h-5
                    w-5
                    shrink-0
                    items-center
                    justify-center
                    rounded-full
                    bg-white/10
                    transition-transform
                    duration-300
                    group-hover:translate-x-1
                    sm:h-6
                    sm:w-6
                  "
                >
                  <ArrowRight
                    size={14}
                    strokeWidth={2.2}
                    className="sm:h-[15px] sm:w-[15px]"
                  />
                </span>
              </button>
            </motion.div>
          </div>
        </div>
      </section>

      <AnimatePresence>
        {isContactModalOpen && (
          <ContactModal
            isOpen={isContactModalOpen}
            onClose={handleCloseContactModal}
            initialService="Legal Services"
            initialSubService=""
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default HeroSection;